<div class="header">
    <div class="title-group">
        <h1 class="title">{{ title() }}</h1>
        @if (description()) {
            <p class="description">{{ description() }}</p>
        }
    </div>
    <div class="actions">
        <ng-content />
    </div>
</div>
